import React from 'react';
import { Locale } from '../i18n/landing';
import { useLocale } from '../i18n/LocaleContext';
import { analytics, WebAnalyticsEvent } from '../analytics/analyticsService';
import logoWordmark from '../assets/images/logo.png';

const LOCALES: Locale[] = ['en', 'sk', 'ua'];

export const Header = (): React.JSX.Element => {
  const { locale, setLocale, t } = useLocale();

  return (
    <nav className="nav">
      <div className="wrap nav-inner">
        <a className="logo" href="/#top">
          <img className="logo-wordmark" src={logoWordmark} alt="gather" />
        </a>
        <div className="nav-links">
          <a href="/#features">{t('nav.features')}</a>
          <a href="/#how">{t('nav.how')}</a>
          <a href="/#faq">{t('nav.faq')}</a>
        </div>
        <div className="nav-right">
          <div className="locale" role="group" aria-label="Language">
            <svg
              className="locale-globe"
              viewBox="0 0 24 24"
              width="15"
              height="15"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              aria-hidden
            >
              <circle cx="12" cy="12" r="9" />
              <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
            </svg>
            {LOCALES.map((loc) => (
              <button
                key={loc}
                type="button"
                className={loc === locale ? 'on' : undefined}
                onClick={() => setLocale(loc)}
              >
                {loc.toUpperCase()}
              </button>
            ))}
          </div>
          <a
            className="btn btn-primary btn-glow"
            href="/#download"
            onClick={() => analytics.logEvent(WebAnalyticsEvent.CTA_CLICK, { location: 'header' })}
          >
            {t('nav.cta')}
          </a>
        </div>
      </div>
    </nav>
  );
};
